import React, {useCallback, useEffect, useRef, useState} from "react";
import styled from "@emotion/styled";
import CustomInput from "../../_common/component/CustomInput";
import {REGEX_BIRTH, REGEX_NAME, REGEX_PHONE} from "../../../constant/regexs";
import SubmitButton from "../../_common/component/SubmitButton";
import {BROADCAST_ON_SUBMIT_FIND_EMAIL, useApplicationContext} from "../../../context/ApplicationContextProvider";
import {lang} from "../../../lang";
import {FIND_EMAIL_INIT_SET} from "../../../constant/options";
import {useModelContext} from "../../../context/ModelContextProvider";
import {useDialogContext} from "../../../context/DialogContextProvider";
import Log from "../../../common/Log";

const FindEmailForm = () => {
    const {account_model, isSuccess, isError} = useModelContext();
    const {alert} = useDialogContext();
    const {broadcast} = useApplicationContext();

    // state
    const [name_error, setNameError] = useState(false);
    const [birth_error, setBirthError] = useState(false);
    const [phone_error, setPhoneError] = useState(false);
    const [is_loading, setIsLoading] = useState(false);

    // ref
    const find_user_info = useRef(FIND_EMAIL_INIT_SET);

    //css style
    const {view} = useComponentStyle();

    const validateInputValue = useCallback(() => {
        let name = find_user_info.current.name.value;
        let birth = find_user_info.current.birth.value;
        let phone = find_user_info.current.phone.value;

        // name, birth, phone 중 하나라도 없는 경우
        if (!name || !birth || !phone) {
            !name && (find_user_info.current.name.error_msg = lang.modify_info.empty_modify_name);
            !birth && (find_user_info.current.birth.error_msg = lang.modify_info.empty_modify_birth);
            !phone && (find_user_info.current.phone.error_msg = lang.modify_info.empty_modify_phone);
        }
        // name이 있는 경우 정규식 체크
        if (name) {
            !REGEX_NAME.test(name)
                ? (find_user_info.current.name.error_msg = lang.modify_info.check_modify_name)
                : (find_user_info.current.name.error_msg = null);
        }
        // birth가 있는 경우 정규식 체크
        if (birth) {
            !REGEX_BIRTH.test(birth)
                ? (find_user_info.current.birth.error_msg = lang.modify_info.check_modify_birth)
                : (find_user_info.current.birth.error_msg = null);
        }
        // phone이 있는 경우 정규식 체크
        if (phone) {
            !REGEX_PHONE.test(phone)
                ? (find_user_info.current.phone.error_msg = lang.modify_info.check_modify_phone)
                : (find_user_info.current.phone.error_msg = null);
        }
        if (
            find_user_info.current.name.error_msg === null &&
            find_user_info.current.birth.error_msg === null &&
            find_user_info.current.phone.error_msg === null
        ) {
            setNameError(false);
            setBirthError(false);
            setPhoneError(false);
            submitFindEmail();
        } else {
            find_user_info.current.name.error_msg && setNameError(true);
            find_user_info.current.birth.error_msg && setBirthError(true);
            find_user_info.current.phone.error_msg && setPhoneError(true);
        }
    }, []);

    useEffect(() => {
        const unlisten = broadcast.listen([BROADCAST_ON_SUBMIT_FIND_EMAIL], ({value}) => {
            value && validateInputValue();
        });
        return () => {
            broadcast.unlisten(unlisten);
        };
    }, [broadcast, validateInputValue]);

    const submitFindEmail = async () => {
        setIsLoading(true);

        let tmp = {
            name: find_user_info.current.name.value,
            birth: find_user_info.current.birth.value,
            phone: find_user_info.current.phone.value.replace(/[^0-9]/g, ""),
        };

        const find_email_res = await account_model.postFindEmail(tmp);

        if (isSuccess(find_email_res)) {
            alert(`해당 정보로 가입된 계정은 ${find_email_res.data.account_name} 입니다`);
        } else if (isError(find_email_res)) {
            if (find_email_res.code === 4500) {
                alert(lang.find_account.does_not_exist_user);
            } else {
                alert(lang.request.request_error);
            }
            Log.private("postFindEmail 에러", find_email_res);
        }
        setIsLoading(false);
    };

    return (
        <>
            <view.FindEmailFormSection>
                <CustomInput
                    placeholder={"이름을 입력해주세요."}
                    name={"name"}
                    need_label={true}
                    label_name={"이름"}
                    regex={REGEX_NAME}
                    on_change={(text) => (find_user_info.current.name.value = text)}
                    current_value={find_user_info.current.name}
                    is_error={name_error}
                />
                <CustomInput
                    max_length={10}
                    placeholder={"ex) 2022-07-07"}
                    name={"birth"}
                    need_label={true}
                    label_name={"생년월일"}
                    regex={REGEX_BIRTH}
                    on_change={(text) => {
                        find_user_info.current.birth.value = text;
                    }}
                    current_value={find_user_info.current.birth}
                    is_error={birth_error}
                />
                <CustomInput
                    max_length={13}
                    placeholder={"'-'를 제거하고 입력해주세요"}
                    name={"phone"}
                    need_label={true}
                    label_name={"휴대폰"}
                    regex={REGEX_PHONE}
                    on_change={(text) => (find_user_info.current.phone.value = text)}
                    current_value={find_user_info.current.phone}
                    is_error={phone_error}
                />
            </view.FindEmailFormSection>
            <SubmitButton
                on_click={validateInputValue}
                button_text={"확인"}
                margin_top={"5em"}
                is_loading={is_loading}
            />
        </>
    );
};

export default FindEmailForm;

export const useComponentStyle = () => {
    return {
        view: {
            FindEmailFormSection: styled.div({
                marginTop: "2em",
                "& > div": {
                    marginTop: "2em",
                    marginBottom: "3em",
                },
            }),
        },
    };
};
